<template>
  <div :class="swag + ' position-fixed alert  overflow-auto'">
    <slot> </slot>
  </div>
</template>

<script>
export default { props: ["swag"] }
</script>

<style lang="scss" scoped></style>
